module.exports = __webpack_public_path__ + "img/clipboard-list-check-duotone.d62ed6c6.svg";